export default __webpack_public_path__ + "static/media/rebranding-banner.86c03be1.png";